module.exports = __webpack_public_path__ + "static/coinbase.b08ce506.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Exchanges/coinbase.png
// module id = 457
// module chunks = 35783957827783